import { render, staticRenderFns } from "./DownGoodsConfirm.vue?vue&type=template&id=342dad9c&scoped=true&"
import script from "./DownGoodsConfirm.vue?vue&type=script&lang=js&"
export * from "./DownGoodsConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DownGoodsConfirm.vue?vue&type=style&index=0&id=342dad9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342dad9c",
  null
  
)

export default component.exports